
import { useState } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    phone: '',
    projectType: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d4birdvhkbdsb76v76gg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          company: '',
          email: '',
          phone: '',
          projectType: '',
          message: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <section id="contact" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block bg-blue-100 text-blue-900 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            Contacto Profesional
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-blue-900 mb-6">
            Hablemos de tu Proyecto
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Nuestro equipo de expertos está listo para asesorarte. Completa el formulario y nos pondremos en contacto contigo en menos de 24 horas.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* Contact Form */}
          <div className="bg-blue-50 rounded-2xl p-8 md:p-10">
            <form onSubmit={handleSubmit} data-readdy-form id="contact-form">
              <div className="grid md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label className="block text-sm font-semibold text-blue-900 mb-2">
                    Nombre Completo *
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-blue-900 focus:ring-2 focus:ring-blue-900/20 outline-none transition-all text-sm"
                    placeholder="Juan Pérez"
                  />
                </div>
                <div>
                  <label className="block text-sm font-semibold text-blue-900 mb-2">
                    Empresa *
                  </label>
                  <input
                    type="text"
                    name="company"
                    value={formData.company}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-blue-900 focus:ring-2 focus:ring-blue-900/20 outline-none transition-all text-sm"
                    placeholder="Constructora ABC"
                  />
                </div>
              </div>

              <div className="grid md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label className="block text-sm font-semibold text-blue-900 mb-2">
                    Email Profesional *
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-blue-900 focus:ring-2 focus:ring-blue-900/20 outline-none transition-all text-sm"
                    placeholder="contacto@empresa.com"
                  />
                </div>
                <div>
                  <label className="block text-sm font-semibold text-blue-900 mb-2">
                    Teléfono *
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-blue-900 focus:ring-2 focus:ring-blue-900/20 outline-none transition-all text-sm"
                    placeholder="+34 600 000 000"
                  />
                </div>
              </div>

              <div className="mb-6">
                <label className="block text-sm font-semibold text-blue-900 mb-2">
                  Tipo de Proyecto *
                </label>
                <select
                  name="projectType"
                  value={formData.projectType}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 pr-8 rounded-lg border border-gray-300 focus:border-blue-900 focus:ring-2 focus:ring-blue-900/20 outline-none transition-all text-sm cursor-pointer"
                >
                  <option value="">Selecciona una opción</option>
                  <option value="residential">Proyecto Residencial</option>
                  <option value="commercial">Proyecto Comercial</option>
                  <option value="retail">Retail</option>
                  <option value="office">Oficinas</option>
                  <option value="other">Otro</option>
                </select>
              </div>

              <div className="mb-6">
                <label className="block text-sm font-semibold text-blue-900 mb-2">
                  Cuéntanos sobre tu Proyecto *
                </label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  maxLength={500}
                  rows={5}
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-blue-900 focus:ring-2 focus:ring-blue-900/20 outline-none transition-all resize-none text-sm"
                  placeholder="Describe brevemente tu proyecto, necesidades y plazos estimados..."
                ></textarea>
                <div className="text-right text-xs text-gray-500 mt-1">
                  {formData.message.length}/500 caracteres
                </div>
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-blue-900 text-white py-4 rounded-lg font-semibold hover:bg-blue-800 transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
              >
                {isSubmitting ? (
                  <>
                    <i className="ri-loader-4-line animate-spin mr-2"></i>
                    Enviando...
                  </>
                ) : (
                  <>
                    <i className="ri-send-plane-fill mr-2"></i>
                    Enviar Solicitud
                  </>
                )}
              </button>

              {submitStatus === 'success' && (
                <div className="mt-4 bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded-lg">
                  <i className="ri-check-line mr-2"></i>
                  ¡Mensaje enviado con éxito! Nos pondremos en contacto pronto.
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="mt-4 bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-lg">
                  <i className="ri-error-warning-line mr-2"></i>
                  Error al enviar el mensaje. Por favor, inténtalo de nuevo.
                </div>
              )}
            </form>
          </div>

          {/* Contact Information */}
          <div>
            <div className="bg-gradient-to-br from-blue-900 to-blue-700 rounded-2xl p-8 md:p-10 text-white mb-8">
              <h3 className="text-2xl font-bold mb-6">Información de Contacto</h3>
              
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="w-12 h-12 flex items-center justify-center bg-blue-800 rounded-lg mr-4 flex-shrink-0">
                    <i className="ri-map-pin-line text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold mb-1">Oficina Central</h4>
                    <p className="text-blue-100">C/ PICO DE LA CIERVA 1</p>
                    <p className="text-blue-100">28031 - MADRID</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-12 h-12 flex items-center justify-center bg-blue-800 rounded-lg mr-4 flex-shrink-0">
                    <i className="ri-phone-line text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold mb-1">Teléfono</h4>
                    <p className="text-blue-100">+34 688 06 61 41</p>
                    <p className="text-blue-100 text-sm">Lun - Vie: 9:00 - 18:00</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-12 h-12 flex items-center justify-center bg-blue-800 rounded-lg mr-4 flex-shrink-0">
                    <i className="ri-mail-line text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold mb-1">Email</h4>
                    <p className="text-blue-100">info@zhongmingimport.com</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-12 h-12 flex items-center justify-center bg-blue-800 rounded-lg mr-4 flex-shrink-0">
                    <i className="ri-global-line text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold mb-1">Oficina en China</h4>
                    <p className="text-blue-100">Guangzhou, Guangdong Province</p>
                    <p className="text-blue-100 text-sm">Inspección y Control de Calidad</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gray-100 rounded-2xl p-8">
              <h3 className="text-xl font-bold text-blue-900 mb-4">Horario de Atención</h3>
              <div className="space-y-3">
                <div className="flex justify-between items-center">
                  <span className="text-gray-700">Lunes - Viernes</span>
                  <span className="font-semibold text-blue-900">9:00 - 18:00</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-700">Sábado</span>
                  <span className="font-semibold text-gray-500">Cerrado</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-700">Domingo</span>
                  <span className="font-semibold text-gray-500">Cerrado</span>
                </div>
              </div>
              <div className="mt-6 pt-6 border-t border-gray-300">
                <p className="text-sm text-gray-600">
                  <i className="ri-information-line mr-2 text-blue-900"></i>
                  Para urgencias fuera del horario laboral, contacta a través del email.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
